export const getAppName = () => {
  return process.env.APP_NAME;
}